export const MAX_COLORS_PER_PALETTE = 10;

export const hexColorPattern = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export const PRESET_COLORS = [
	'#FFFFFF',
	'#1A1A1A',
	'#0066FF',
	'#6C757D',
	'#28A745',
	'#DC3545',
	'#FFC107',
	'#0E2A47',
	'#F8F9FA',
	'#6F42C1',
];
